export const SET_WAREHOUSE_SEARCH = "SET_WAREHOUSE_SEARCH";
export function setWarehouseSearchQueryFilter(payload) {
  return {
    type: SET_WAREHOUSE_SEARCH,
    payload
  };
}

export const SET_WAREHOUSE_LIST = "SET_WAREHOUSE_LIST";
export function setWarehouseList(payload) {
  return {
    type: SET_WAREHOUSE_LIST,
    payload
  };
}

export const SET_VISIBLE_WAREHOUSE_LIST = "SET_VISIBLE_WAREHOUSE_LIST";
export function setVisibleWarehouseList(payload) {
  return {
    type: SET_VISIBLE_WAREHOUSE_LIST,
    payload
  };
}

export const VIEW_ASSIGNED_WAREHOUSE = "VIEW_ASSIGNED_WAREHOUSE";
export function viewAssignedWarehouses(payload) {
  return {
    type: VIEW_ASSIGNED_WAREHOUSE,
    payload
  };
}

export const ADD_GEOFENCE_WITH_UPDATED_WAREHOUSES =
  "ADD_GEOFENCE_WITH_UPDATED_WAREHOUSES";
export function addGeofenceWithUpdatedWarehouses(payload) {
  return {
    type: ADD_GEOFENCE_WITH_UPDATED_WAREHOUSES,
    payload
  };
}

export const ASSIGN_WAREHOUSES_BUDDY_BLOCK = "ASSIGN_WAREHOUSES_BUDDY_BLOCK";
export function assignWarehousesToBuddyblock(payload) {
  return {
    type: ASSIGN_WAREHOUSES_BUDDY_BLOCK,
    payload
  };
}

export const ASSIGN_WAREHOUSES_WAREHOUSE_FENCES =
  "ASSIGN_WAREHOUSES_WAREHOUSE_FENCES";

export function assignWarehousesToWarehouseFence(payload) {
  return {
    type: ASSIGN_WAREHOUSES_WAREHOUSE_FENCES,
    payload
  };
}

export const SET_DRAWING_OPTS = "SET_DRAWING_OPTS";
export function setDrawingOpts(payload) {
  return {
    type: SET_DRAWING_OPTS,
    payload
  };
}

export const SET_SELECTED_VERTEX = "SET_SELECTED_VERTEX";
export function setSelectedVertex(payload) {
  return {
    type: SET_SELECTED_VERTEX,
    payload
  };
}

export const SET_TO_PUBLISH_FENCE = "SET_TO_PUBLISH_FENCE";
export function setToPublishFence(payload) {
  return {
    type: SET_TO_PUBLISH_FENCE,
    payload
  };
}

export const ADD_VISIBLE_LAYER = "ADD_VISIBLE_LAYER";
export function addVisibleLayer(payload) {
  return {
    type: ADD_VISIBLE_LAYER,
    payload
  };
}

export const REMOVE_VISIBLE_LAYER = "REMOVE_VISIBLE_LAYER";
export function removeVisibleLayer(payload) {
  return {
    type: REMOVE_VISIBLE_LAYER,
    payload
  };
}

// TODO: refactor into common actions
export const VIEW_ASSIGNED_BUDDIES = "VIEW_ASSIGNED_BUDDIES";
export function viewAssignedBuddies(payload) {
  return {
    type: VIEW_ASSIGNED_BUDDIES,
    payload
  };
}

export const SET_ASSIGNED_BUDDIES = "SET_ASSIGNED_BUDDIES";
export function setAssignedBuddies(payload) {
  return {
    type: SET_ASSIGNED_BUDDIES,
    payload
  };
}

export const SET_SELECTED_POLYGON_ID = "SET_SELECTED_POLYGON_ID";
export function setSelectedPolygonId(payload) {
  return {
    type: SET_SELECTED_POLYGON_ID,
    payload
  };
}

export const ADD_JUST_PUBLISHED_GEOFENCE = "ADD_JUST_PUBLISHED_GEOFENCE";
export function addJustPublishedGeofence(payload) {
  return {
    type: ADD_JUST_PUBLISHED_GEOFENCE,
    payload
  };
}

export const SET_TO_PUBLISH_FENCE_NAME = "SET_TO_PUBLISH_FENCE_NAME";
export function setToPublishFenceName(payload) {
  return {
    type: SET_TO_PUBLISH_FENCE_NAME,
    payload
  };
}

export const EDIT_SELECTED_ID_FENCE = "EDIT_SELECTED_ID_FENCE";
export function editSelectedFence(payload) {
  return {
    type: EDIT_SELECTED_ID_FENCE,
    payload
  };
}

export const DELETE_SELECTED_ID_FENCE = "DELETE_SELECTED_ID_FENCE";
export function deleteReqSelectedFence(payload) {
  return {
    type: DELETE_SELECTED_ID_FENCE,
    payload
  };
}

export const REMOVE_SELECTED_ID_FENCE = "REMOVE_SELECTED_ID_FENCE";
export function removeSelectedFence(payload) {
  return {
    type: REMOVE_SELECTED_ID_FENCE,
    payload
  };
}

export const FETCH_ORDER_LOCS = "FETCH_ORDER_LOCS";
export function fetchOrderLocs(payload) {
  return {
    type: FETCH_ORDER_LOCS,
    payload
  };
}

export const SET_ORDER_PINS = "SET_ORDER_PINS";
export function setOrderpins(payload) {
  return {
    type: SET_ORDER_PINS,
    payload
  };
}

export const SET_ORDER_PINS_DATE_RANGE = "SET_ORDER_PINS_DATE_RANGE";
export function setOrderpinsDateRange(payload) {
  return {
    type: SET_ORDER_PINS_DATE_RANGE,
    payload
  };
}

export const SET_30_DAYS_DATE_RANGE = "SET_30_DAYS_DATE_RANGE";

export function setOrderpins30DaysRange(payload) {
  return {
    type: SET_30_DAYS_DATE_RANGE,
    payload
  };
}

export const SET_SEARCH_QUERY_FILTER = "SET_SEARCH_QUERY_FILTER";
export function setSearchQueryFilter(payload) {
  return {
    type: SET_SEARCH_QUERY_FILTER,
    payload
  };
}

export const REMOVE_CATEGORY_FROM_FILTER = "REMOVE_CATEGORY_FROM_FILTER";
export function removeCategoryFromFilter(payload) {
  return {
    type: REMOVE_CATEGORY_FROM_FILTER,
    payload
  };
}

export const ADD_CATEGORY_TO_FILTER = "ADD_CATEGORY_TO_FILTER";
export function addCategoryToFilter(payload) {
  return {
    type: ADD_CATEGORY_TO_FILTER,
    payload
  };
}

export const PUBLISH_SELECTED_ID_FENCE = "PUBLISH_SELECTED_ID_FENCE";
export function publishSelectedGeofence(payload) {
  return {
    type: PUBLISH_SELECTED_ID_FENCE,
    payload
  };
}

export const CANCEL_EDIT_FENCE = "CANCEL_EDIT_FENCE";
export function cancelEditSelectedGeofence(payload) {
  return {
    type: CANCEL_EDIT_FENCE,
    payload
  };
}

export const CANCEL_CREATE_FENCE = "CANCEL_CREATE_FENCE";
export function cancelGeofenceCreation(payload) {
  return {
    type: CANCEL_CREATE_FENCE,
    payload
  };
}

export const SET_TO_PUBLISH_FENCE_CATEGORY = "SET_TO_PUBLISH_FENCE_CATEGORY";
export function setToPublishFenceCategory(payload) {
  return {
    type: SET_TO_PUBLISH_FENCE_CATEGORY,
    payload
  };
}

export const SET_CITY_NAME = "SET_CITY_NAME";
export function setCurrentCityName(payload) {
  return {
    type: SET_CITY_NAME,
    payload
  };
}

export const SET_LOADER = "SET_LOADER";
export function setLoaderModal(payload) {
  return {
    type: SET_LOADER,
    payload
  };
}

export const FETCH_AVAILABLE_CITIES = "FETCH_AVAILABLE_CITIES";
export function fetchAvailableCities(payload) {
  return {
    type: FETCH_AVAILABLE_CITIES,
    payload
  };
}

export const SET_AVAILABLE_CITIES = "SET_AVAILABLE_CITIES";
export function setAvailableCities(payload) {
  return {
    type: SET_AVAILABLE_CITIES,
    payload
  };
}

export const SET_GEOFENCES = "SET_GEOFENCES";
export function setGeofences(payload) {
  return {
    type: SET_GEOFENCES,
    payload
  };
}

export const SET_VISIBLE_GEOFENCES = "SET_VISIBLE_GEOFENCES";
export function setVisibleGeofences(payload) {
  return {
    type: SET_VISIBLE_GEOFENCES,
    payload
  };
}

export const SET_NEW_CITY_NAME = "SET_NEW_CITY_NAME";
export function setCityName(payload) {
  return {
    type: SET_NEW_CITY_NAME,
    payload
  };
}

export const SET_NEW_CITY_BOUNDS = "SET_NEW_CITY_BOUNDS";
export function setCityBounds(payload) {
  return {
    type: SET_NEW_CITY_BOUNDS,
    payload
  };
}

export const SEARCH_CITY_BOUNDS = "SEARCH_CITY_BOUNDS";
export function searchBounds(payload) {
  return {
    type: SEARCH_CITY_BOUNDS,
    payload
  };
}

export const SEARCH_AREA_BOUNDS = "SEARCH_AREA_BOUNDS";
export function searchAreaBounds(payload) {
  return {
    type: SEARCH_AREA_BOUNDS,
    payload
  };
}

export const PUBLISH_CITY = "PUBLISH_CITY";
export function publishCity(payload) {
  return {
    type: PUBLISH_CITY,
    payload
  };
}

export const PUBLISH_GEOFENCE = "PUBLISH_GEOFENCE";
export function publishGeofence(payload) {
  return {
    type: PUBLISH_GEOFENCE,
    payload
  };
}

export const ERROR_TOAST_MESSAGE = "ERROR_TOAST_MESSAGE";
export function setErrorToastMessage(payload) {
  return {
    type: ERROR_TOAST_MESSAGE,
    payload
  };
}

export const SUCCESS_TOAST_MESSAGE = "SUCCESS_TOAST_MESSAGE";
export function setSuccessToastMessage(payload) {
  return {
    type: SUCCESS_TOAST_MESSAGE,
    payload
  };
}

export const SET_BOUNDS = "SET_BOUNDS";
export function setBounds(payload) {
  return {
    type: SET_BOUNDS,
    payload
  };
}

export const SET_MAP_CENTER = "SET_MAP_CENTER";
export function setMapCenter(payload) {
  return {
    type: SET_MAP_CENTER,
    payload
  };
}

export const SET_MAP_ZOOM = "SET_MAP_ZOOM";
export function setMapZoom(payload) {
  return {
    type: SET_MAP_ZOOM,
    payload
  };
}

export const TOGGLE_LOADING = "TOGGLE_LOADING";
export function toggleLoading() {
  return {
    type: TOGGLE_LOADING
  };
}

export const ADD_GEOFENCES = "ADD_GEOFENCES";
export function addGeofences(payload) {
  return {
    type: ADD_GEOFENCES,
    payload
  };
}

export const AUTHENTICATE_USER = "AUTHENTICATE_USER";
export function authenticateUser(payload) {
  return {
    type: AUTHENTICATE_USER,
    payload
  };
}

export const LOGOUT_USER = "LOGOUT_USER";
export function logoutUser(payload) {
  return {
    type: LOGOUT_USER,
    payload
  };
}

export const SET_USER_AUTHENTICATED = "SET_USER_AUTHENTICATED";
export function setUserAuthenticated(payload) {
  return {
    type: SET_USER_AUTHENTICATED,
    payload
  };
}

export const CHECK_USER_LOGGED_IN = "CHECK_USER_LOGGED_IN";
export function checkUserLoggedIn(payload) {
  return {
    type: CHECK_USER_LOGGED_IN,
    payload
  };
}

export const SET_REPLAY_ON_AUTH = "SET_REPLAY_ON_AUTH";
export function setReplayOnAuthentication(payload) {
  return {
    type: SET_REPLAY_ON_AUTH,
    payload
  };
}

export const FETCH_ADDITIONAL_CITY_FENCES = "FETCH_ADDITIONAL_CITY_FENCES";
export function fetchAdditionalCityFences(payload) {
  return {
    type: FETCH_ADDITIONAL_CITY_FENCES,
    payload
  };
}

export const ADD_ADDITIONAL_CITY_GEOFENCES = "ADD_ADDITIONAL_CITY_GEOFENCES";
export function addAddtionalCityGeofences(payload) {
  return {
    type: ADD_ADDITIONAL_CITY_GEOFENCES,
    payload
  };
}

export const REMOVE_ADDITIONAL_CITY_GEOFENCES =
  "REMOVE_ADDITIONAL_CITY_GEOFENCES";
export function removeAddtionalCityGeofences(payload) {
  return {
    type: REMOVE_ADDITIONAL_CITY_GEOFENCES,
    payload
  };
}
